// extracted by mini-css-extract-plugin
export default {"updateTable":"BaseCostWorkScopesEditModal_updateTable__phz3-"};